<template>
  <v-data-table
    :headers="headers"
    :items="userPins"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="UserPin-button-new"
          @click="$router.push({
            name: 'processing-EditUserPin'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'processing-EditUserPin',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListUserPin',
  module: 'UserPin',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('userPins', ['userPins']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('username'),
          value: 'username',
        },
        {
          text: this.$$t('pin'),
          value: 'pin',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_userPins();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('userPins', ['LOAD_userPins', 'DELETE_userPin']),
    /** Delete UserPin from the collection
     */
    async remove(UserPin) {
      this.isLoading = true;
      await this.DELETE_UserPin(UserPin);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# UserPin example

'''js
<UserPin />
'''
</docs>
